import React from 'react';
import { MapPin, ArrowRight } from 'lucide-react';

export const Coverage = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#204FA7] mb-4">
            Zones des servies
          </h2>
          <p className="text-lg text-gray-600">
            Service de transport régulier entre la France et la Côte d'Ivoire
          </p>
        </div>

        {/* Coverage Routes */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Paris to Abidjan */}
          <div className="bg-gradient-to-br from-blue-50 to-white border-2 border-[#204FA7]/20 rounded-2xl p-8 hover:shadow-xl transition-shadow">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-[#204FA7] rounded-full flex items-center justify-center">
                  <MapPin className="text-white" size={24} />
                </div>
                <div>
                  <p className="text-sm text-gray-600">Départ</p>
                  <p className="text-xl font-bold text-[#204FA7]">Paris</p>
                </div>
              </div>
              <ArrowRight className="text-[#1CA1CC]" size={32} />
              <div className="flex items-center space-x-3">
                <div>
                  <p className="text-sm text-gray-600">Arrivée</p>
                  <p className="text-xl font-bold text-[#F3A530]">Abidjan</p>
                </div>
                <div className="w-12 h-12 bg-[#F3A530] rounded-full flex items-center justify-center">
                  <MapPin className="text-white" size={24} />
                </div>
              </div>
            </div>
            
            <div className="space-y-3">
              <div className="flex items-center space-x-2 text-gray-700">
                <div className="w-2 h-2 bg-[#204FA7] rounded-full"></div>
                <span>Collecte à Paris 75010</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-700">
                <div className="w-2 h-2 bg-[#1CA1CC] rounded-full"></div>
                <span>Transit express</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-700">
                <div className="w-2 h-2 bg-[#F3A530] rounded-full"></div>
                <span>Livraison à Abidjan</span>
              </div>
            </div>
            
            <div className="mt-6 pt-6 border-t border-gray-200">
              <p className="text-sm font-semibold text-[#204FA7]">Délai : 48 heures</p>
            </div>
          </div>

          {/* Abidjan to Paris */}
          <div className="bg-gradient-to-br from-orange-50 to-white border-2 border-[#F3A530]/20 rounded-2xl p-8 hover:shadow-xl transition-shadow">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-[#F3A530] rounded-full flex items-center justify-center">
                  <MapPin className="text-white" size={24} />
                </div>
                <div>
                  <p className="text-sm text-gray-600">Départ</p>
                  <p className="text-xl font-bold text-[#F3A530]">Abidjan</p>
                </div>
              </div>
              <ArrowRight className="text-[#1CA1CC]" size={32} />
              <div className="flex items-center space-x-3">
                <div>
                  <p className="text-sm text-gray-600">Arrivée</p>
                  <p className="text-xl font-bold text-[#204FA7]">Paris</p>
                </div>
                <div className="w-12 h-12 bg-[#204FA7] rounded-full flex items-center justify-center">
                  <MapPin className="text-white" size={24} />
                </div>
              </div>
            </div>
            
            <div className="space-y-3">
              <div className="flex items-center space-x-2 text-gray-700">
                <div className="w-2 h-2 bg-[#F3A530] rounded-full"></div>
                <span>Collecte à Abidjan (4 points)</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-700">
                <div className="w-2 h-2 bg-[#1CA1CC] rounded-full"></div>
                <span>Transit express</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-700">
                <div className="w-2 h-2 bg-[#204FA7] rounded-full"></div>
                <span>Livraison à Paris</span>
              </div>
            </div>
            
            <div className="mt-6 pt-6 border-t border-gray-200">
              <p className="text-sm font-semibold text-[#F3A530]">Délai : 48 heures</p>
            </div>
          </div>
        </div>

        {/* Info Banner */}
        <div className="mt-12 text-center bg-blue-50 rounded-xl p-6">
          <p className="text-gray-700">
            <span className="font-semibold text-[#204FA7]">Service régulier</span> : 
            Départs plusieurs fois par semaine pour garantir une livraison rapide
          </p>
        </div>
      </div>
    </section>
  );
};
